import TextareaController from './TextareaController';
export default TextareaController;
